<div class="gpd-full-page template-config-page">
  <div class="template-card">
    <div class="template-card-header">
      <div>
        <span class="gpd-config-section-title" i18n="@@templatesConfig">Templates</span>
        <p class="gpd-config-section-description" i18n="@@templateConfigDescription">Add new templates or manage existing ones.</p>
      </div>
      <div class="template-header-actions">
        <!-- #686: opens the wiki manual page listing all fillable data fields -->
        <app-gpd-button
          *ngIf="canViewAvailableData"
          type="text"
          icon="info"
          i18n-text="@@viewAvailableData"
          text="View available data"
          (onClick)="openAvailableData()"
        ></app-gpd-button>
        <app-gpd-button
          type="secondary"
          icon="add"
          i18n-text="@@addNewFolder"
          text="Create folder"
          (onClick)="openEdit('new-folder', null)"
        ></app-gpd-button>
        <app-gpd-button
          type="primary"
          icon="add"
          i18n-text="@@uploadTemplate"
          text="Upload Template"
          (onClick)="openUpload(null)"
        ></app-gpd-button>
      </div>
    </div>

    <dx-tree-list
      id="template-tree"
      keyExpr="key"
      parentIdExpr="parentKey"
      [rootValue]="0"
      dataStructure="plain"
      [dataSource]="treeItems"
      [(expandedRowKeys)]="expandedKeys"
      [showColumnHeaders]="true"
      [showBorders]="false"
      [hoverStateEnabled]="true"
      class="template-tree-list"
    >
      <!-- default virtual scrolling renders a fixed row window without a set height and silently hides the rest -->
      <dxo-scrolling mode="standard"></dxo-scrolling>
      <dxo-search-panel [visible]="true" [width]="280" i18n-placeholder="@@searchTemplates" placeholder="Search"></dxo-search-panel>
      <dxi-column dataField="name" cellTemplate="nameTemplate" i18n-caption="@@name" caption="Name"></dxi-column>
      <dxi-column
        dataField="uploadDate"
        dataType="date"
        format="dd.MM.yyyy"
        [width]="140"
        i18n-caption="@@uploadedOn"
        caption="Uploaded on"
        [allowSearch]="false"
      ></dxi-column>
      <dxi-column dataField="uploadedBy" [width]="200" i18n-caption="@@uploadedBy" caption="Uploaded by" [allowSearch]="false"></dxi-column>
      <dxi-column cellTemplate="actionsTemplate" [width]="60" caption="" [allowSearch]="false"></dxi-column>

      <div *dxTemplate="let item of 'nameTemplate'" class="template-row">
        <app-svg-icon [icon]="item.data.isFolder ? 'folder' : 'document'" [size]="16" class="template-row-icon"></app-svg-icon>
        <span class="template-row-name">{{ item.data.name }}</span>
      </div>

      <div *dxTemplate="let item of 'actionsTemplate'" class="template-row-actions">
        <dx-drop-down-button
          icon="overflow"
          stylingMode="text"
          [showArrowIcon]="false"
          [dropDownOptions]="{ width: 180 }"
          [items]="item.data.isFolder ? folderMenuItems : docMenuItems"
          displayExpr="text"
          (onItemClick)="onMenuItemClick($event, item.data)"
        ></dx-drop-down-button>
      </div>
    </dx-tree-list>
  </div>
</div>

<!-- create / rename popup -->
<app-generic-popup
  [visible]="editMode != null"
  (visibleChange)="editMode = null"
  [title]="editTitle"
  [width]="'420px'"
  [allowOutsideClick]="false"
  [buttons]="editButtons"
>
  <div class="template-name-field">
    <label class="template-name-label" i18n="@@folderNameLabel">Name <span class="required-marker">*</span></label>
    <dx-text-box [(value)]="editName" [showClearButton]="true" valueChangeEvent="keyup"></dx-text-box>
  </div>
</app-generic-popup>

<!-- move popup -->
<app-generic-popup
  [(visible)]="moveVisible"
  i18n-title="@@moveTo"
  title="Move To.."
  [width]="'420px'"
  [allowOutsideClick]="false"
  [buttons]="moveButtons"
>
  <div class="template-name-field">
    <label class="template-name-label" i18n="@@targetFolder">Target folder</label>
    <dx-select-box
      [dataSource]="moveTargets"
      valueExpr="id"
      displayExpr="path"
      [(value)]="moveTargetFolderId"
      [searchEnabled]="true"
    ></dx-select-box>
  </div>
</app-generic-popup>

<!-- upload popup -->
<app-generic-popup
  [(visible)]="uploadVisible"
  i18n-title="@@uploadTemplate"
  title="Upload Template"
  [width]="'460px'"
  [allowOutsideClick]="false"
  [buttons]="uploadButtons"
>
  <div class="template-name-field">
    <label class="template-name-label" i18n="@@targetFolder">Target folder</label>
    <dx-select-box
      [dataSource]="flatFolders"
      valueExpr="id"
      displayExpr="path"
      [(value)]="uploadTargetFolderId"
      [searchEnabled]="true"
    ></dx-select-box>
  </div>
  <div class="template-name-field">
    <label class="template-name-label" i18n="@@file">File</label>
    <input type="file" class="template-upload-input" (change)="onFileSelected($event)" />
  </div>
</app-generic-popup>

<!-- delete confirm popup -->
<app-generic-popup
  [(visible)]="deleteVisible"
  i18n-title="@@deleteTitle"
  title="Delete"
  [width]="440"
  [allowOutsideClick]="false"
  [buttons]="deleteButtons"
>
  <ng-container *ngIf="selectedRow?.isFolder; else docDelete">
    <p>{{ deleteFolderPrefix }}<strong>{{ selectedRow?.name }}</strong>{{ deleteFolderSuffix }}</p>
  </ng-container>
  <ng-template #docDelete>
    <p>{{ deleteDocPrefix }}<strong>{{ selectedRow?.name }}</strong>{{ deleteDocSuffix }}</p>
  </ng-template>
</app-generic-popup>
